import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=6c78d2da&scoped=true"
import script from "./vHeader.vue?vue&type=script&lang=js"
export * from "./vHeader.vue?vue&type=script&lang=js"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=6c78d2da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78d2da",
  null
  
)

export default component.exports